export default {
    bem_vindo: {
        titulo: 'Bem-vindo',
        paragrafo1: 'Bem-vindo ao VAM (Veus Automation Management), um painel de onde é possível visualizar e controlar todas as suas automações, sejam com seus equipamentos locais, seja com laboratórios de apoio.',
        paragrafo2: 'Através deste Painel e desta plataforma você poderá acompanhar e controlar todas as atividades dos seus VNS\'s e muito mais, de forma simples, fácil e intuitiva.',
    },
    novidades: {
        titulo: 'Novidades',
        rnds: {
            titulo: 'RNDS',
            data: '20/12/2020',
            texto: 'Nosso sistema está homologado e fornecendo integração à RNDS efetuando transmissão de resultados de COVID.'
        },
        lancamento: {
            titulo: 'Lançamento',
            data: '02/04/2020',
            texto: 'Lançamos nossa plataforma oficialmente em produção, agora você pode viver conosco uma revolução naárea de saúde.'
        },
        monitoramento: {
            titulo: 'Monitoramento',
            data: '25/03/2020',
            texto: 'Agora é possível acompanhar todas as Ordens e Resultados de suas integrações através do Menu de Monitores.'
        },
        dashboard: {
            titulo: 'Dashboard',
            data: '01/02/2020',
            texto: 'Nosso Dashboard está pronto para acesso, acompanhe todos seus dados de automação através de lá.'
        }
    }
}